/** Primary action buttons shown on each buyer dashboard module tab. */
export const BUYER_DASHBOARD_MODULE_ACTIONS = {
  overview: [
    { label: "Create RFQ", to: "/buyer-rfq-form", primary: true },
    { label: "Review Quotes", to: "/seller-quotation-list", primary: false },
  ],
  rfq: [
    { label: "Create RFQ", to: "/buyer-rfq-form", primary: true },
    { label: "Review Quotes", to: "/seller-quotation-list", primary: false },
  ],
  cm: [
    { label: "Browse manufacturers", to: "/dashboard/buyer/contract-manufacturers", primary: true },
    { label: "Review CM quotes", to: "/dashboard/buyer/contract-manufacturers/quotes", primary: false },
  ],
  infra: [
    { label: "Post requirement", to: "/infrastructure-leasing/post-requirement", primary: true },
    { label: "My enquiries", to: "/infrastructure-leasing/my-enquiries", primary: false },
  ],
  p2p: [
    { label: "Command centre", to: "/dashboard/p2p/command-centre", primary: true },
    { label: "My approvals", to: "/dashboard/p2p/my-approvals", primary: false },
  ],
  logistics: [
    { label: "Send logistics RFQ", to: "/logistics/rfq", primary: true },
    { label: "RFQs sent", to: "/logistics-rfqs-sent", primary: false },
  ],
  qa: [
    { label: "Request inspection", to: "/buyer/qa-request", primary: true },
    { label: "Approve QA quotations", to: "/buyer/qa-quotations-list", primary: false },
  ],
  auctions: [
    { label: "Browse auctions", to: "/auction", primary: true },
    { label: "My bids", to: "/auction/my/bids", primary: false },
  ],
};

export function getBuyerDashboardModuleActions(moduleKey) {
  return BUYER_DASHBOARD_MODULE_ACTIONS[moduleKey] || BUYER_DASHBOARD_MODULE_ACTIONS.overview;
}

/** Dashboard routes — tab click stays on buyer dashboard with module-specific data. */
export const BUYER_DASHBOARD_MODULE_ROUTES = {
  overview: "/dashboard/buyer",
  rfq: "/dashboard/buyer/rfq",
  cm: "/dashboard/buyer/cm",
  infra: "/dashboard/buyer/infra",
  p2p: "/dashboard/buyer/p2p",
  logistics: "/dashboard/buyer/logistics",
  qa: "/dashboard/buyer/qa",
  auctions: "/dashboard/buyer/auctions",
};
